import { render } from "./WeddingViewFormType1.vue?vue&type=template&id=3b93b2dc&lang=true"
import script from "./WeddingViewFormType1.vue?vue&type=script&lang=js"
export * from "./WeddingViewFormType1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__